<template>
  <div class="image-container">
    <amplify-s3-image  v-if="selectedImagePath" :imagePath="selectedImagePath"
                      :key="selectedImagePath">

    </amplify-s3-image>
    <div v-if="!selectedImagePath">
      <div v-if="!selectedImagePath">
        <v-btn :loading="loading" fab depressed color="primary" class="picker-btn" @click="$refs.file_input.click()">
          <v-icon>camera_alt</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-else class="change-img" v-ripple="{ class: 'white--text' }" @click="$refs.file_input.click()">
      <v-spacer></v-spacer>
      <div class="bottom-block">
         <v-progress-circular v-if="loading" size="20" width="2"
          indeterminate
          color="white"
        ></v-progress-circular>
        <v-icon color="white" v-else>camera_alt</v-icon>

      </div>
    </div>
    <input
      ref="file_input"
      type="file"
      accept="options.accept"
      @change="pick"
      style="display:none"
    />
    <div class="photo-error error--text" v-if="error">
      {{ error }}
    </div>
  </div>

</template>

<script>
  import {AmplifyEventBus} from 'aws-amplify-vue';

  export default {
    name: 'PhotoPicker',
    props: ['photoPickerConfig', 'value'],
    data() {
      return {
        loading: false,
        file: null,
        s3ImagePath: '',
        photoUrl: '',
        error: '',
        selectedImagePath: this.value
      }
    },
    watch: {
      value() {
        this.selectedImagePath = this.value
      }
    },
    computed: {
      options() {
        const defaults = {
          accept: '*/*',
          storageOptions: {
            level: 'public'
          }
        }
        return Object.assign(defaults, this.photoPickerConfig || {})
      },
    },
    mounted() {
      if (!this.options.path) {
        return this.setError('File path not provided.');
      }
      if (this.options.path.substr(this.options.path.length - 1) !== '/') {
        this.options.path = this.options.path + '/';
      }
      if (this.value) {
        this.selectedImagePath = this.value
      }
    },
    methods: {
      upload() {
        this.loading = true
        this.$Amplify.Storage.put(
          this.s3ImagePath,
          this.file,
          this.options.storageOptions,
        )
          .then((result) => {
            this.completeFileUpload(result.key)
            this.loading = false
          })
          .catch((e) => {
            this.loading = false
            this.setError(e)

          });
      },
      pick(evt) {
        this.file = evt.target.files[0];
        if (!this.file) {
          return;
        }
        ;
        if (!this.options.storageOptions.contentType) {
          this.options.storageOptions.contentType = this.file.type;
        }
        ;
        const name = this.options.defaultName ? this.options.defaultName : this.file.name;
        var ts = Date.now()
        this.s3ImagePath = `${this.options.path}${ts}/${name}`;
        const that = this;
        const reader = new FileReader();
        reader.onload = (e) => {
          const target = e.target;
          const url = target.result;
          that.photoUrl = url;
          this.upload()
        }
        reader.readAsDataURL(this.file);
      },
      completeFileUpload(img) {
        this.file = null;
        this.s3ImageFile = null;
        this.$refs.file_input.value = null;
        this.selectedImagePath = img
        this.$emit('input', img)
      },
      setError: function (e) {
        this.error = e.message || e;
      }
    }
  }
</script>
<style lang="scss">
  .picker-btn {
    height: 84px !important;
    width: 84px !important;
  }

  .image-container {
    padding: 1.5rem;
    min-height: 140px;
    text-align: -webkit-center;
    position: relative;

    .change-img {
      margin: auto;
      top: 24px;
      right: 0;
      left: 0;
      position: absolute;
      height: 84px;
      width: 84px;
      border-radius: 50%;
      background-color: transparent;
      overflow: hidden;
      display: grid;
      grid-template-rows: 1fr auto;

      .bottom-block {
        height: 30px;
        width: 100%;
        background-color: rgba(#1565c0, 0.7);

        .v-icon {
          margin-top: 2px;
        }
      }
    }

    .amplify-image {
      border: 0px solid white;
      width: 84px !important;
      height: 84px !important;
      border-radius: 50%!important;
      margin: 0px;
    }
  }

  .photo-error {
    grid-row-end: span 2
  }

</style>



// WEBPACK FOOTER //
// src/Brands/PhotoPicker.vue